import React, { useState, useEffect } from 'react';
import './Slider.css';

const Slider = ({ slides }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        if (isPaused) return; // 🔒 don’t auto-slide while hovered

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isPaused, slides.length]);

    const handleSlideClick = (index) => {
        setCurrentIndex(index);
    };

    return (
        <div
            className="slider-container"
            onMouseEnter={() => setIsPaused(true)}   // 🛑 pause on hover
            onMouseLeave={() => setIsPaused(false)} // ▶️ resume on leave
        >
            <div
                className="slider"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {slides.map((slide, index) => (
                    <div className="slide" key={index}>
                        {slide}
                    </div>
                ))}
            </div>
            <div className="line-bar">
                {slides.map((_, index) => (
                    <div
                        key={index}
                        className={index === currentIndex ? 'line active' : 'line'}
                        onClick={() => handleSlideClick(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Slider;
